import { render, staticRenderFns } from "./SelectCateDialog.vue?vue&type=template&id=2da9fa6a&scoped=true&"
import script from "./SelectCateDialog.vue?vue&type=script&lang=js&"
export * from "./SelectCateDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectCateDialog.vue?vue&type=style&index=0&id=2da9fa6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9fa6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da9fa6a')) {
      api.createRecord('2da9fa6a', component.options)
    } else {
      api.reload('2da9fa6a', component.options)
    }
    module.hot.accept("./SelectCateDialog.vue?vue&type=template&id=2da9fa6a&scoped=true&", function () {
      api.rerender('2da9fa6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/SelectCateDialog.vue"
export default component.exports